import { render, staticRenderFns } from "./PxShowAtivoProduto.vue?vue&type=template&id=45f3faac&scoped=true&"
import script from "./PxShowAtivoProduto.vue?vue&type=script&lang=js&"
export * from "./PxShowAtivoProduto.vue?vue&type=script&lang=js&"
import style0 from "./PxShowAtivoProduto.vue?vue&type=style&index=0&id=45f3faac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f3faac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
